import React from 'react';
import { Link } from 'react-router-dom';

interface BasePageProps {
    title?: string;
    children: React.ReactNode;
}

function BasePage(props: BasePageProps) {
    const currentYear = new Date().getFullYear();

    return (
        <div className="container-fluid min-vh-100 d-flex flex-column">
            <header className="py-3 mb-4">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container-fluid">
                        <Link className="navbar-brand fw-bold" to="/">
                            Aszendent Berechnen
                        </Link>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">
                                        Rechner
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#faq">
                                        FAQ
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                {props.title && <h1 className="text-center">{props.title}</h1>}
            </header>
            <main className="flex-grow-1">
                <div className="container">
                    {props.children}
                </div>
            </main>
            <footer className="bg-light py-4 mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center mb-3">
                            <Link to="/" className="text-decoration-none">
                                <strong>aszendent-berechnen.net</strong>
                            </Link>
                        </div>
                        <div className="col-12 text-center">
                            <p className="mb-1">© {currentYear} Aszendent Berechnen</p>
                            <p className="mb-0 small text-muted">Kostenloser Aszendent Rechner</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default BasePage;
